import React from 'react'
import { useLayoutEffect, useEffect, useState, useRef } from 'react';
import './ComponentsCss/MonthlySunjin.css';
import YoutubeEmbed from './YoutubeEmbed';
import backButton from '../imgs/back.png';
// axios 
import axios from 'axios';
const MonthlySunjin = () => {

    const [AllMsData, SetAllMsData] = useState();
    const [msExpand, SetMsExpand] = useState(false);
    const [msSelected, SetMsSelected] = useState(0);
    useEffect(() => {
        axiosMontlySunjin();
    }, []);
    // https://stepupkorea.kr/api/Lawyer/allLawyerData
    const axiosMontlySunjin = async () => {
        console.log(" axiosAllLawyerData ");

        var finalIP = "";
        // https://stepupkorea.kr/api/msData/getAllMsData
        finalIP = "https://stepupkorea.kr/api/msData/getAllMsData";
        try {
            const response = await axios.get(finalIP

            );
            if (response) {
                console.log(response.data);
                SetAllMsData(response.data);
                //SetNewsListsArray(response.data);
            } else {

            }

        } catch (err) {

            if (!err?.response) {
                console.log('--No Server Response');
            } else if (err.response?.status === 400) {
                console.log('--Missing Username or Password');
            } else if (err.response?.status === 401) {
                console.log('--Unauthorized');
            } else {
                console.log('ERR');
            }

        }
    }

    return (


        <div className='ms-main-frame'>
              <div style={{ height: "150px" }}>
              </div>
            <div className='ms-text-xxl'>月刊先進</div>
            <div className='ms-separator'></div>
            {
                msExpand ?
                    <>
                        <div className='back-button-flex'>
                            <img src={backButton} style={{ width: "30px", height: "30px" }} onClick={() => SetMsExpand(false)} />
                        </div>
                        <div className='ms-responsive-video-box'>
                            <div className='ms-flex-col'>
                                <YoutubeEmbed embedId={AllMsData[msSelected]?.msLink} />
                                <div className='ms-text-xxl ms-text-black '> {AllMsData[msSelected]?.msTitle} </div>
                            </div>
                        </div>

                    </>
                    :
                    <>
                        <div className='ms-flex-row '>
                            {

                                AllMsData != null && AllMsData.length > 0 ?
                                    AllMsData.map((msData, index) => (
                                        <div className='ms-responsive-box' onClick={() => { SetMsExpand(true); SetMsSelected(index) }}>
                                            <div className='lawyer-list-margin-tb-10'>
                                                <img src={"https://stepupkorea.kr/images/ms/" + msData?.msImage}
                                                    className="lawyer-image" />

                                                <div className='ms-text-xxl ms-text-black '> {msData?.msTitle} </div>
                                            </div>
                                        </div>

                                    ))
                                    : null
                            }

                        </div>
                    </>
            }


            <div style={{ marginBottom: "150px" }}>

            </div>
        </div>

    )
}
/*

*/

export default MonthlySunjin